/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { Map } from 'immutable'

import TagConstants from 'constants/TagConstants'
import CampaignConstants from 'constants/CampaignConstants'
import CampaignQueries from 'queries/CampaignQueries'
import ReduxStore from 'containers/store'

const CampaignStore = Marty.createStore({
  id: 'CampaignStore',

  getInitialState() {
    return {
      campaignsById: {},
      successReportsByCampaignId: {},
      interactionIdsByCampaignId: Map(),
      campaignsByEndUserId: {},
      campaignResultsById: {},
      campaignMembersResponseByKey: {},
      announcementDraft: {},
      NPSDraft: {},
      testCampaignEmails: {},
      updateCampaignStateById: {}
    }
  },

  handlers: {
    fetchCampaignsDone: CampaignConstants.CAMPAIGNS_FETCH_DONE,
    fetchCampaignDone: CampaignConstants.CAMPAIGN_FETCH_DONE,
    createCampaignDone: CampaignConstants.CAMPAIGN_CREATE_DONE,
    updateCampaignDone: CampaignConstants.CAMPAIGN_UPDATE_DONE,
    updateCampaignFailed: CampaignConstants.CAMPAIGN_UPDATE_FAILED,

    fetchCampaignResultsDone: CampaignConstants.CAMPAIGN_RESULTS_FETCH_DONE,
    fetchCampaignMembersDone: CampaignConstants.CAMPAIGN_MEMBERS_FETCH_DONE,

    fetchCampaignsForEndUserIdDone:
      CampaignConstants.CAMPAIGNS_FOR_END_USER_FETCH_DONE,

    saveAnnouncementDraft: CampaignConstants.SAVE_ANNOUNCEMENT_DRAFT,
    saveNPSDraft: CampaignConstants.SAVE_NPS_DRAFT,

    deleteCampaign: CampaignConstants.CAMPAIGN_DELETE_DONE,

    sendTestCampaignStarting: CampaignConstants.SEND_TEST_CAMPAIGN_STARTING,
    sendTestCampaignDone: CampaignConstants.SEND_TEST_CAMPAIGN_DONE,
    sendTestCampaignFailed: CampaignConstants.SEND_TEST_CAMPAIGN_FAILED
  },

  saveAnnouncementDraft(updates) {
    let announcementDraft = _.cloneDeep(this.state.announcementDraft)
    announcementDraft = _.assign(announcementDraft, updates)
    return this.setState({ announcementDraft })
  },

  saveNPSDraft(updates) {
    let NPSDraft = _.cloneDeep(this.state.NPSDraft)
    NPSDraft = _.assign(NPSDraft, updates)
    return this.setState({ NPSDraft })
  },

  getAnnouncementDraft() {
    return this.state.announcementDraft
  },

  resetAnnouncementDraft() {
    return this.setState({ announcementDraft: {}})
  },

  getNPSDraft() {
    return this.state.NPSDraft
  },

  resetNPSDraft() {
    return this.setState({ NPSDraft: {}})
  },

  getOrFetchCampaigns() {
    return this.fetch({
      id: 'getOrFetchCampaigns',

      locally() {
        if (this.hasAlreadyFetched('getOrFetchCampaigns')) {
          return this.state.campaignsById
        }
      },

      remotely() {
        return this.app.queries.CampaignQueries.fetchCampaigns()
      }
    })
  },

  getOrFetchCampaign(id, accessToken = null) {
    return this.fetch({
      id: `getOrFetchCampaign${ id }`,
      locally() {
        return this.state.campaignsById[id]
      },
      remotely() {
        return this.app.queries.CampaignQueries.fetchCampaign(id, accessToken)
      }
    })
  },

  getOrFetchCampaignsForEndUserId(endUserId) {
    return this.fetch({
      id: `getOrFetchCampaignsForEndUserId${ endUserId }`,

      locally() {
        return this.state.campaignsByEndUserId[endUserId]
      },

      remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignsForEndUserId(endUserId)
      }
    })
  },

  getOrFetchCampaignResults(campaignId) {
    return this.fetch({
      id: `getOrFetchCampaignResults${ campaignId }`,

      locally() {
        return this.state.campaignResultsById[campaignId]
      },

      remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignResults(campaignId)
      }
    })
  },

  campaignPeriodKey(campaignId, periodTimestamp) {
    let key = campaignId
    if (periodTimestamp != null) { key += `-${periodTimestamp}` }
    return key
  },

  getOrFetchCampaignMembers(campaignId, query) {
    const key = `${ campaignId }${ (query != null) ? JSON.stringify(query) : '' }`
    return this.fetch({
      id: `getOrFetchCampaignMembers${ key }`,

      locally() {
        return this.state.campaignMembersResponseByKey[key]
      },

      remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignMembers(campaignId, query)
      }
    })
  },

  fetchCampaignResultsDone(campaignId, results) {
    const campaignResultsById = _.cloneDeep(this.state.campaignResultsById)
    campaignResultsById[campaignId] = results
    return this.setState({ campaignResultsById })
  },

  fetchCampaignMembersDone(campaignId, query, response) {
    const campaignMembersResponseByKey = _.cloneDeep(this.state.campaignMembersResponseByKey)
    const key = `${ campaignId }${ (query != null) ? JSON.stringify(query) : '' }`
    campaignMembersResponseByKey[key] = response
    return this.setState({ campaignMembersResponseByKey })
  },

  fetchCampaignsDone(campaigns) {
    const campaignsById = _.cloneDeep(this.state.campaignsById)
    _.each(campaigns, campaign => campaignsById[campaign.id] = campaign)
    return this.setState({ campaignsById })
  },

  setCampaign(id, campaign) {
    const campaignsById = _.cloneDeep(this.state.campaignsById)
    campaignsById[id] = campaign
    const newState = { campaignsById }
    if (campaign.type === 'BOT') {
      newState.interactionIdsByCampaignId = this.state.interactionIdsByCampaignId.set(
        campaign.id,
        campaign.attributes.interactionId
      )
    }
    return this.setState(newState)
  },

  fetchCampaignDone(id, campaign) {
    return this.setCampaign(id, campaign)
  },

  updateCampaignDone(id, campaign) {
    this.setCampaign(id, campaign)
    this.state.updateCampaignStateById[id] = campaign
    return this.setState({ updateCampaignStateById: this.state.updateCampaignStateById })
  },

  updateCampaignFailed(id, campaign) {
    this.state.updateCampaignStateById[id] = CampaignConstants.CAMPAIGN_UPDATE_FAILED
    return this.setState({ updateCampaignStateById: this.state.updateCampaignStateById })
  },

  getUpdateCampaignStateById() {
    return this.state.updateCampaignStateById
  },

  createCampaignDone(campaign) {
    return this.setCampaign(campaign.id, campaign)
  },

  fetchCampaignsForEndUserIdDone(endUserId, campaigns) {
    const campaignsByEndUserId = _.cloneDeep(this.state.campaignsByEndUserId)
    campaignsByEndUserId[endUserId] = campaigns
    return this.setState({ campaignsByEndUserId })
  },

  deleteCampaign(campaignId) {
    const campaignsById = _.cloneDeep(this.state.campaignsById)
    delete campaignsById[campaignId]
    return this.setState({ campaignsById })
  },

  getTestCampaignStatus(campaign) {
    return _.cloneDeep(this.state.testCampaignEmails[campaign.name])
  },

  sendTestCampaignStarting(campaign, emails) {
    const testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails)
    testCampaignEmails[campaign.name] = { sending: true }
    return this.setState({ testCampaignEmails })
  },

  sendTestCampaignDone(campaign, emails) {
    const testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails)
    testCampaignEmails[campaign.name] = { sending: false, success: true }
    return this.setState({ testCampaignEmails })
  },

  sendTestCampaignFailed(campaign, emails) {
    const testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails)
    testCampaignEmails[campaign.name] = { sending: false, success: false }
    return this.setState({ testCampaignEmails })
  }
})

export default CampaignStore



// WEBPACK FOOTER //
// ./src/scripts/stores/CampaignStore.js